import http from '../../core/services/http'

export const generateMenuChangeFrequencyReport = ({ menuType }) =>
  http.get('/reports/menu-change-frequency', {
    params: menuType ? { menuType } : {},
    responseType: 'blob',
  })
